import React from "react";
import type { TFunction } from "i18next";

import IconUpdate from "~/components/Icons/icon-update";
import { Settings } from "~/components/Icons/default/Settings";
import { ROLE_TYPES } from "~/constans/roles";

import s from "~/pages/Users/Users.less";
import tableV2 from "~/shared/ui/TableV2/ui/TableV2.less";

const USER_ROLES_WITHOUT_DC_BUTTON = [
  ROLE_TYPES.ADMIN.name,
  ROLE_TYPES.LEADER.name,
  ROLE_TYPES.ADMIN_DATA.name,
  ROLE_TYPES.AUTOVAZ.name,
];

const canShowUserDcButton = (record: { role?: string }) =>
  record.role != null && !USER_ROLES_WITHOUT_DC_BUTTON.includes(record.role);

export type UsersTableRowActionsRecord = {
  status?: string;
  role?: string;
  id?: string | number;
};

type Props = {
  record: UsersTableRowActionsRecord;
  onRowRestore?: (record: UsersTableRowActionsRecord) => void;
  onOpenDc?: (record: UsersTableRowActionsRecord) => void;
  t: TFunction;
};

export const UsersTableRowActions = ({
  record,
  onRowRestore,
  onOpenDc,
  t,
}: Props) => (
  <>
    {record.status === "removed" && onRowRestore && (
      <div
        className={tableV2.rowControlBtn}
        onClick={() => onRowRestore(record)}
        title={t("ui.restore")}
        role="presentation"
      >
        <span className={s.restoreRowIcon}>
          <IconUpdate fill="#495964" />
        </span>
      </div>
    )}
    {canShowUserDcButton(record) && onOpenDc && (
      <div
        className={tableV2.rowControlBtn}
        onClick={() => onOpenDc(record)}
        title={t("ui.DC")}
        role="presentation"
      >
        <Settings fill="#495964" />
      </div>
    )}
  </>
);
